import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=3f78521a&"
import script from "./Shares.vue?vue&type=script&lang=ts&"
export * from "./Shares.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports